import React, { Component } from 'react';
import { Link } from 'react-router';
import logoImg from './logo.png';
import styles from './BlogLogo.css';

class BlogLogo extends Component {
  render() {
    return (
      <Link to={`/journal`} alt="link to journal">
        <img src={logoImg} className={styles.logo} alt="blog logo" />
      </Link>
    );
  }
}

export default BlogLogo;



// WEBPACK FOOTER //
// ./src/components/blog-logo/BlogLogo.js